import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {Format} from '../../../../common/utils';
import styles from './FieldAmount.module.scss';

const FieldAmount = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-amount',
    defaultMessage: 'Amount'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta, helper] = useField<string>({name: 'amount'});
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    helper.setValue(Format.formatToFloatValue(e));
  };
  const handleBlur = () => {
    helper.setValue(Format.formatValueToFixed(field.value, 2));
  };

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      onChange={handleChange}
      onBlur={handleBlur}
      value={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldAmount;
